export const queryTest = /^[A-Za-z0-9-_]*$/
export const dateTest = /^[0-9]{4}\.[0-9]{1,2}\.[0-9]{1,2}$/
export const isCsv = /\.csv$/
export const emailTest = /(?=^.{5,50}$)^.+@\w+\.\w+/
export const passwordTest = /(?=.*\d)(?=.*[a-z])(?=.*[\W_]).{6,50}/
export const codeInputTest = /^\d{0,4}$/
export const codeTest = /^\d{4}$/